import Marquee from "react-fast-marquee";
import { Plane } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLanguage();
  return (
    <div data-testid="editorial-marquee" className="py-10 border-y border-white/10 bg-[#020617] overflow-hidden">
      <Marquee speed={35} gradient={false}>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-black text-5xl md:text-7xl tracking-tight text-outline mx-6 whitespace-nowrap">
              {item}
            </span>
            <Plane size={28} className="text-[#2563EB] mx-2 shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
